import * as Factory from 'factory.ts'
import faker from 'faker'

import { CreditCardVendors } from '@webapp/core/entities/external/CreditCardVendor'
import { CurrencyConstructorFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  CreditCardAccount,
  type CreditCardAccountConstructor,
} from './CreditCardAccount'

export const CreditCardAccountConstructorFactory =
  Factory.Sync.makeFactory<CreditCardAccountConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.company.companyName()),
    number: '4242424242425978',
    type: CreditCardVendors.VISA,
    currency: Factory.each(() => CurrencyConstructorFactory.build()),
    vendor: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.company.companyName(),
    })),
    glCode: '',
    assignees: [],
    lastReconciliationDate: '2023-12-31',
    lastReconciliationBalance: Factory.each(() => faker.random.number()),
    lastStatementDate: '2024-01-31',
    session: null,
  })

export const CreditCardAccountFactory = EntityFactory(
  CreditCardAccount,
  CreditCardAccountConstructorFactory
)
